/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetMenuAvailability200ResponseProductsInner } from './GetMenuAvailability200ResponseProductsInner';
import {
    GetMenuAvailability200ResponseProductsInnerFromJSON,
    GetMenuAvailability200ResponseProductsInnerFromJSONTyped,
    GetMenuAvailability200ResponseProductsInnerToJSON,
    GetMenuAvailability200ResponseProductsInnerToJSONTyped,
} from './GetMenuAvailability200ResponseProductsInner';

/**
 * 
 * @export
 * @interface GetMenuAvailability200Response
 */
export interface GetMenuAvailability200Response {
    /**
     * 
     * @type {Array<GetMenuAvailability200ResponseProductsInner>}
     * @memberof GetMenuAvailability200Response
     */
    products: Array<GetMenuAvailability200ResponseProductsInner>;
    /**
     * 
     * @type {Array<GetMenuAvailability200ResponseProductsInner>}
     * @memberof GetMenuAvailability200Response
     */
    combos: Array<GetMenuAvailability200ResponseProductsInner>;
    /**
     * 
     * @type {Array<GetMenuAvailability200ResponseProductsInner>}
     * @memberof GetMenuAvailability200Response
     */
    modifiers: Array<GetMenuAvailability200ResponseProductsInner>;
    /**
     * 
     * @type {Array<GetMenuAvailability200ResponseProductsInner>}
     * @memberof GetMenuAvailability200Response
     */
    modifierGroups: Array<GetMenuAvailability200ResponseProductsInner>;
}

/**
 * Check if a given object implements the GetMenuAvailability200Response interface.
 */
export function instanceOfGetMenuAvailability200Response(value: object): value is GetMenuAvailability200Response {
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('combos' in value) || value['combos'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    if (!('modifierGroups' in value) || value['modifierGroups'] === undefined) return false;
    return true;
}

export function GetMenuAvailability200ResponseFromJSON(json: any): GetMenuAvailability200Response {
    return GetMenuAvailability200ResponseFromJSONTyped(json, false);
}

export function GetMenuAvailability200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuAvailability200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerFromJSON)),
        'combos': ((json['combos'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerFromJSON)),
        'modifiers': ((json['modifiers'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerFromJSON)),
        'modifierGroups': ((json['modifierGroups'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerFromJSON)),
    };
}

export function GetMenuAvailability200ResponseToJSON(json: any): GetMenuAvailability200Response {
    return GetMenuAvailability200ResponseToJSONTyped(json, false);
}

export function GetMenuAvailability200ResponseToJSONTyped(value?: GetMenuAvailability200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerToJSON)),
        'combos': ((value['combos'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerToJSON)),
        'modifiers': ((value['modifiers'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerToJSON)),
        'modifierGroups': ((value['modifierGroups'] as Array<any>).map(GetMenuAvailability200ResponseProductsInnerToJSON)),
    };
}

